/**
 * This file contains all Product Specific types that we can want to use internally
 * These types should not be exposed to our customers (ie on the UI)
 * but used for engineers facing tasks (error capturing, metrics etc)
 */
export var ProductFamily;
(function (ProductFamily) {
    ProductFamily["DashpassForWork"] = "DashpassForWork";
    ProductFamily["ExpensedMeals"] = "ExpensedMeals";
})(ProductFamily || (ProductFamily = {}));
// Actions that a user can take when administrating the product
export var ProductWorkflow;
(function (ProductWorkflow) {
    ProductWorkflow["CreateTeam"] = "CreateTeam";
    ProductWorkflow["AddTeamMember"] = "AddTeamMember";
    ProductWorkflow["RemoveTeamMember"] = "RemoveTeamMember";
    ProductWorkflow["AddPaymentCard"] = "AddPaymentCard";
    ProductWorkflow["ActivateBenefit"] = "ActivateBenefit";
    ProductWorkflow["DeactivateBenefit"] = "DeactivateBenefit";
    ProductWorkflow["SendJoinInvitationToAllPendingMembers"] = "SendJoinInvitationToAllPendingMembers";
    ProductWorkflow["SendJoinInvitationToSelectedMembers"] = "SendJoinInvitationToSelectedMembers";
})(ProductWorkflow || (ProductWorkflow = {}));
export var CustomerType;
(function (CustomerType) {
    CustomerType["ManagedCustomer"] = "ManagedCustomer";
    CustomerType["SelfServeCustomer"] = "SelfServeCustomer";
    CustomerType["UnknownCustomerType"] = "UnknownCustomerType";
})(CustomerType || (CustomerType = {}));
